/* ================================================================ */
// ADMIN LAYOUT CONTAINER | AdminLayout.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Auth0
import { useAuth0 } from '../../auth0/auth0';
// MaterialUI
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/styles/makeStyles';
// Constants
import {LayoutTypes} from '@myglobe/core/dist/types';
// Validators
//import LayoutConfig from './LayoutConfig';
// Local Components
import Admin from '../../containers/Admin';
import UserToolbar from '../../components/Admin/UserToolbar';
// MyGlobe Library
// Hooks
//import useMedia from '@myglobe/core/dist/hooks/useMedia';
// > ASYNC
//const Drawer = React.lazy(()=>import('@myglobe/core/dist/Layout/Drawer'));
//const GridLayout = React.lazy(()=>import('@myglobe/core/dist/Layout/Grid'));
//const LayeredLayout = React.lazy(()=>import('@myglobe/core/dist/Layout/Layered'));
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(({
    'body': {
        transition: 'all 0.25s linear'
    },
    root: {
        // overflow: 'hidden',
        // position: 'relative',
        // width: '100%',
        // height: '100vh',
        // display: 'flex',
        //background:'pink',
        // transition: 'all 500ms cubic-bezier(0.215, 0.610, 0.355, 1.000)',
    },
    navigation: {

    }
}));
/* ========================================== */
/**
 * Admin Layout
 * ------------
 * Admin dashboard layout
 *
 * @param {object} props component props
 */
const AdminLayout = React.memo((props) => {
    const classes = useStyles();
    const rootClasses = classNames(classes.root);
    return (
        <main className={rootClasses}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" href="/">
                    Home
                </Link>
                <Link color="inherit" href="/admin">
                    Admin
                </Link>
                <Typography color="textPrimary">Datasets</Typography>
            </Breadcrumbs>
            <UserToolbar />
            <Admin />
        </main>
    );
});
/* ========================================== */
// Props
/* ========================================== */
AdminLayout.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    theme: PropTypes.object
};
AdminLayout.types = LayoutTypes;
AdminLayout.displayName = 'AdminLayout';
AdminLayout.whyDidYouRender = true;
/* ========================================== */
// Exports
/* ========================================== */
export default AdminLayout;